module.exports = __webpack_public_path__ + "img/Angiogenesis-PRCA_10X_ACC.84ec97fc.png";